import type { FunctionComponent, ReactNode } from "react";
import { graphql, useFragment } from "react-relay";

import type { headerMorningStudioArticle$key } from "~/queries/__generated__/headerMorningStudioArticle.graphql";

import { MorningStudioMobileSubheader } from "./mobile-subheader";
import {
  BackgroundImageContainer,
  BackgroundImageDesktop,
  BackgroundImageDesktopContainer,
  BackgroundImageMobile,
  Container,
  Content,
  Headline,
  StyledArticleSponsor,
} from "./styles";
import { MorningStudioSubheader } from "./subheader";

type Props = {
  children: ReactNode;
  className?: string;
  reference: headerMorningStudioArticle$key;
};

export const MorningStudioHeader: FunctionComponent<Props> = ({
  children,
  className,
  reference: reference_,
}) => {
  const article = useFragment(
    graphql`
      fragment headerMorningStudioArticle on Article {
        ...articleSponsorContent
        ...subheaderMorningStudioSubheaderContent
        headline
        coverDesktop: image(filter: { type: COVER }) {
          url
        }
        coverMobile: image(filter: { type: COVER_MOBILE }) {
          url
        }
      }
    `,
    reference_,
  );

  const desktopImageUrl = article.coverDesktop?.url ?? "";
  const mobileImageUrl = article.coverMobile?.url ?? "";

  return (
    <Container className={className}>
      <MorningStudioMobileSubheader />
      <MorningStudioSubheader reference={article} />
      <BackgroundImageContainer>
        <BackgroundImageDesktopContainer>
          {desktopImageUrl ? <BackgroundImageDesktop src={desktopImageUrl} /> : <>{children}</>}
        </BackgroundImageDesktopContainer>

        <BackgroundImageMobile src={mobileImageUrl} />
      </BackgroundImageContainer>

      <Content>
        <Headline>{article.headline}</Headline>

        <StyledArticleSponsor
          reference={article}
          sponsorTagStyle={{ color: "#FFFFFF", layoutAlignment: "center" }}
        />
      </Content>
    </Container>
  );
};
